<!--
  Generated template for the Home page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
-->

<div class="inPage-header-box" slot="fixed">
    <div class="inPage-header-wrapper"
         [ngClass]="{'dark': (ads && ads.length == 0) && offers.length == 0 && (!brand?.crm?.addPoints  ) }">
        <custom-back-button [forceHideText]="true"
                            (backButtonClick)="backButtonClick()"></custom-back-button>

        <ion-button *ngIf="hasCrmId || memberService.getMember()" fill="clear" (click)="goProfile()">
            <ion-icon name="md-person"></ion-icon>
            <p>{{"pages.member-reward.profile" | translate}}</p>
        </ion-button>
    </div>
</div>

<ion-content>
    <div *ngIf="offers.length != 0 || brand?.crm?.addPoints" class="top-container">
        <div class="point-info-wrapper">
            <ng-container *ngIf="brand?.crm?.addPoints">
                <p class="page-title">{{"pages.member-reward.points-accu" | translate}}</p>
                <div class="point-info-ctn flex-row-std">
                    <div id="point">0</div>
                </div>
            </ng-container>
            
        </div>
    </div>
    <ion-segment (ionChange)="segmentChanged($event)" mode="md">
    <ion-segment-button *ngIf="offers.length > 0 " [checked]= "sagmentValue === 'reward'" value="reward">
            <ion-label>Reward</ion-label>
        </ion-segment-button>
        <ion-segment-button *ngIf="enableStamps" [checked]= "sagmentValue === 'stamps'" value="stamps">
            <ion-label>Stamps</ion-label>
        </ion-segment-button>
        <ion-segment-button *ngIf="ads.length > 0" [checked]= "sagmentValue === 'promotion'"value="promotion">
            <ion-label>Recent promotion</ion-label>
        </ion-segment-button>
    </ion-segment>
    <div class="sagment-content">
        <!-- reward -->
        <ng-container *ngIf="offers.length > 0 && sagmentValue === 'reward'">
            <div>
                <p class="page-title">{{"pages.member-reward.reward-available" | translate}}</p>
                <div class="qa-box">
                    <span id="qa-trigger" (click)="qaBoxEvent()">{{"pages.member-reward.how-to-use" | translate}}
                        ?</span>
                    <span *ngIf="qaOpened" id="qa-response" (click)="qaBoxEvent()">
                        <p>{{"pages.member-reward.apply-coupon" | translate}}</p>
                    </span>
                </div>
            </div>
            <div class="upSell-wrapper">
                <div class="upSell-ctn">
                    <div *ngFor="let offer of offers;let i = index" class="usi-box AQA-reward-item"
                        >
                        <!-- (click)="openRewardList(offer)" -->
                        
                        <div *ngIf="offer.reward.getImage('default', 200)" class="reward-img-box"
                            [ngStyle]="{'background-image': 'url(' + offer.reward.getImage('default', 200) + ')'}"></div>
                        
                        <p class="detail-text">{{offer.reward.name}}</p>
                        <p class="desc-text">{{"pages.member-reward.valid-from" | translate}}
                            : {{offer.expire | date:'yyyy-MM-dd' }}</p>
                        
                        <ion-button *ngIf="!isAvailableReward(offer); else notAvailable" fill="outline" size="small" disable
                            color="light">{{"pages.member-reward.valid-from" | translate}} {{offer.start | date:'d MMM' }}
                        </ion-button>
                        <ng-template #notAvailable>
                            <!-- <ion-button fill="outline" size="small" color="success"
                                (click)="redeemReward(offer);$event.stopPropagation()">
                                {{"pages.member-reward.use" | translate}}</ion-button> -->
                        </ng-template>
    
                    </div>
                </div>
            </div>
        </ng-container>
        
        <!-- stamps -->
        <section class="coupon-wrapper stamp-wrapper" *ngIf="enableStamps && sagmentValue === 'stamps'">
            <div>
                <p class="page-title">{{"pages.member-reward.stamps" | translate}}</p>
            </div>
            <ion-card>
                <div class="stamp" *ngFor="let stamp of totalStamps;let i = index">
                    <div class="stamp-box" tappable (click)="clickedStamp(stamp,i)"
                        [ngClass]="{'stamp-active' : stamp?.active}">
                        <div *ngIf="stamp.active" class="stamp-inner-graphic"></div>
                        <div *ngIf="!stamp.active" class="stamp-inner">{{stamp?.showNumber}}</div>
                        <div tappable class="virtual-stamp-btn" *ngIf="stamp.active && stamp?.showNumber == 6"
                            (click)="clickedRedeem(stamp);$event.stopPropagation()"></div>
                    </div>
                </div>
                <p class="hint-text">{{"pages.member-reward.stamp-rule" | translate}}</p>
                <!-- TODO go to category page -->
                <ion-button appThrottleClick color="primary" (click)="onRewardListClick()">
                    {{"pages.splash.reward-list" | translate}}
                    <ion-icon slot="end" name="arrow-round-forward"></ion-icon>
                </ion-button>
            </ion-card>
    
        </section>
    
        <!-- promotion -->
        <div class="promotion-wrapper" [ngClass]="{'offer-wrapper-offset' : offers.length > 0}" *ngIf="ads.length > 0 && sagmentValue === 'promotion'">
            <p class="page-title">{{"pages.member-reward.recent-promotion" | translate}}</p>
            <ion-slides options="{slidesPerView:'auto',centeredSlides:true,spaceBetween:10}" class="slide-box">
                <ion-slide *ngFor="let ad of ads" class="slides" (click)="goToPromotion(ad)">
                    <img src="{{ad.getImage('default', 500)}}">
                    <p>{{ad.name}}</p>
                </ion-slide>
            </ion-slides>
        </div>
    </div>

    <div *ngIf="ads.length == 0 && offers.length == 0 && (!brand?.crm?.addPoints ) "
         class="empty-mem-box">
         
         <div class="mem-img-box">
                <img src="assets/images/reward-page-images.png" [ngStyle]="{'margin-bottom': '50px', 'max-width': '100%', 'height': '100px' }">
            
            <!-- <ion-text color="medium">{{"pages.member-reward.empty-mem" | translate}}</ion-text> -->
            <ion-text color="medium">Unique Japanese Specialties All-In-One Destination</ion-text>
        </div>
    </div>
    <div class="btn-box">
        <!-- TODO go to category page -->
        <ion-button color="primary" (click)="startOrder()">
            {{"pages.splash.start" | translate}}
            <ion-icon slot="end" name="arrow-round-forward"></ion-icon>
        </ion-button>
    </div>

</ion-content>
